import { ReactNode } from "react";

interface FacilityDetailsSectionProps {
  title: string;
  children: ReactNode;
}

const FacilityDetailsSection = ({ title, children }: FacilityDetailsSectionProps) => (
  <div className="tw-border tw-border-border tw-rounded-lg tw-overflow-hidden tw-bg-card">
    <div className="tw-px-4 tw-py-2.5 tw-bg-primary/5 tw-border-b tw-border-border">
      <p className="tw-text-sm tw-font-semibold tw-text-primary">{title}</p>
    </div>
    {children}
  </div>
);

export default FacilityDetailsSection;
